import React from "react";
import PageHeader from "../components/PageHeader";
import { INDUSTRIES } from "../data/mock";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import ContactCTA from "../components/ContactCTA";

const IndustriesPage = () => (
  <>
    <PageHeader
      title="Industries We Serve"
      subtitle="Sector-specialised ISO consulting for manufacturing, IT, healthcare, food, automotive, energy, laboratories and more."
      crumbs={[{ label: "Industries" }]}
    />
    <section className="section-pad bg-white">
      <div className="lis-container grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {INDUSTRIES.map((ind) => {
          const Icon = Icons[ind.icon] || Icons.Building2;
          return (
            <div key={ind.name} className="p-6 rounded-2xl border border-slate-100 card-hover bg-white">
              <div className="w-12 h-12 rounded-lg bg-red-50 text-brand flex items-center justify-center">
                <Icon size={22} />
              </div>
              <h3 className="mt-4 text-lg font-semibold text-slate-900">{ind.name}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{ind.desc}</p>
              <Link to="/contact" className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-brand">
                Discuss your requirement <ArrowRight size={14} />
              </Link>
            </div>
          );
        })}
      </div>
    </section>
    <ContactCTA />
  </>
);

export default IndustriesPage;
